import React from 'react'
import { Link } from 'react-router-dom'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { Pagination, Subsection, Table } from '@fourthwall/components'

import type { Order } from '../../../../../__models__'
import { useShopTime } from '../../../../Timezone/providers/ShopTimeProvider'
import { getProductOrdersTableHeaders } from './getProductOrdersTableHeaders/getProductOrdersTableHeaders'
import { getTableRowLink } from './getTableRowLink/getTableRowLink'

export type ProductOrdersViewProps = {
  orders?: Order[]
  isLoading: boolean
  totalPages?: number
  currentPage: number
  onCurrentPageChange: (page: number) => void
}

export const ProductOrdersView = ({
  orders,
  isLoading,
  totalPages,
  currentPage,
  onCurrentPageChange,
}: ProductOrdersViewProps) => {
  const { hasPermission } = useDashboardPermissions()
  const { timezoneAbbreviation } = useShopTime()

  if (!orders || !orders.length) {
    return null
  }

  return (
    <Subsection title="Orders for this product" borderless>
      <Dashboard.Section.Item>
        <Dashboard.Section.ScrollableContent>
          <Table
            data={orders}
            headers={getProductOrdersTableHeaders({
              hideProfitColumn: !hasPermission('contributions.profit'),
              timezoneAbbreviation,
            })}
            isLoading={isLoading}
            rowComponent={Link}
            getRowLink={getTableRowLink}
          />
        </Dashboard.Section.ScrollableContent>
      </Dashboard.Section.Item>
      {!!totalPages && (
        <Dashboard.Section.Item>
          <Pagination
            pageCount={totalPages}
            currentPage={currentPage}
            onChange={onCurrentPageChange}
          />
        </Dashboard.Section.Item>
      )}
    </Subsection>
  )
}
